import { render, staticRenderFns } from "./AccountContactRole.vue?vue&type=template&id=31ce0c2e&slot=default"
import script from "./AccountContactRole.vue?vue&type=script&lang=js"
export * from "./AccountContactRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports